"use strict";

var React = require("react");

var ErrorSumary = React.createClass({
    displayName: "ErrorSumary",

    render: function render() {
        var errors = this.props.errors.map(function (error) {
            return React.createElement(
                "p",
                { key: error.id },
                error.msg
            );
        });

        return React.createElement(
            "div",
            { className: "ui error form segment" },
            React.createElement(
                "div",
                { className: "ui error message" },
                React.createElement(
                    "div",
                    { className: "header" },
                    "Errors: "
                ),
                errors
            )
        );
    }
});

module.exports = ErrorSumary;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVycm9yLXN1bWFyeS5qc3giXSwibmFtZXMiOlsiUmVhY3QiLCJyZXF1aXJlIiwiRXJyb3JTdW1hcnkiLCJjcmVhdGVDbGFzcyIsInJlbmRlciIsImVycm9ycyIsInByb3BzIiwibWFwIiwiZXJyb3IiLCJpZCIsIm1zZyIsIm1vZHVsZSIsImV4cG9ydHMiXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBSUEsUUFBUUMsUUFBUSxPQUFSLENBQVo7O0FBRUEsSUFBSUMsY0FBY0YsTUFBTUcsV0FBTixDQUFrQjtBQUFBOztBQUNoQ0MsWUFBUSxrQkFBWTtBQUNoQixZQUFJQyxTQUFTLEtBQUtDLEtBQUwsQ0FBV0QsTUFBWCxDQUFrQkUsR0FBbEIsQ0FBc0IsVUFBU0MsS0FBVCxFQUFlO0FBQzlDLG1CQUNJO0FBQUE7QUFBQSxrQkFBRyxLQUFLQSxNQUFNQyxFQUFkO0FBQW1CRCxzQkFBTUU7QUFBekIsYUFESjtBQUdILFNBSlksQ0FBYjs7QUFNQSxlQUNJO0FBQUE7QUFBQSxjQUFLLFdBQVUsdUJBQWY7QUFDSTtBQUFBO0FBQUEsa0JBQUssV0FBVSxrQkFBZjtBQUNJO0FBQUE7QUFBQSxzQkFBSyxXQUFVLFFBQWY7QUFBQTtBQUFBLGlCQURKO0FBRUtMO0FBRkw7QUFESixTQURKO0FBUUg7QUFoQitCLENBQWxCLENBQWxCOztBQW1CQU0sT0FBT0MsT0FBUCxHQUFpQlYsV0FBakIiLCJmaWxlIjoiZXJyb3Itc3VtYXJ5LmpzeCIsInNvdXJjZXNDb250ZW50IjpbInZhciBSZWFjdCA9IHJlcXVpcmUoXCJyZWFjdFwiKTtcblxudmFyIEVycm9yU3VtYXJ5ID0gUmVhY3QuY3JlYXRlQ2xhc3Moe1xuICAgIHJlbmRlcjogZnVuY3Rpb24gKCkge1xuICAgICAgICB2YXIgZXJyb3JzID0gdGhpcy5wcm9wcy5lcnJvcnMubWFwKGZ1bmN0aW9uKGVycm9yKXtcbiAgICAgICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICAgICAgPHAga2V5PXtlcnJvci5pZH0+e2Vycm9yLm1zZ308L3A+XG4gICAgICAgICAgICApXG4gICAgICAgIH0pO1xuXG4gICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInVpIGVycm9yIGZvcm0gc2VnbWVudFwiPlxuICAgICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwidWkgZXJyb3IgbWVzc2FnZVwiPlxuICAgICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cImhlYWRlclwiPkVycm9yczogPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgIHtlcnJvcnN9XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgKVxuICAgIH1cbn0pO1xuXG5tb2R1bGUuZXhwb3J0cyA9IEVycm9yU3VtYXJ5OyJdfQ==